import { createContext } from 'react';
import { dispatchFunc } from '../hook/useEditSubTablehook';
import { FormInstance } from "antd/lib/form";

export interface IBaseEditSubTableContext {
  tableDataSource?: any[];
  form?: FormInstance;
  expandedRowKeys?: string[];
  showAddSubRow?: boolean;
  showEmptySubRow?: boolean;
}
export interface IEdiTableContext extends IBaseEditSubTableContext {
  dispatchEditSubTable: dispatchFunc;
}
export default createContext<IEdiTableContext>({
  dispatchEditSubTable: () => {},
});